import { useTranslation } from 'react-i18next';
import { APP_ROUTES } from 'shared/constants';

import NavigationInternalLink from './NavigationInternalLink';

export default function ContactsLink({ closeNav }: { closeNav?: () => void; }) {
    const { t } = useTranslation('navigation');

    return (
        <NavigationInternalLink 
            url={ APP_ROUTES.contacts }
            label={ t('navigationItem.contacts') }
            closeNav={ closeNav }
        />
    );
}
